import { connectorsByIdentifier } from "./index";

type DestinationState = {
  identifier: string;
  urlPattern: string;
  configuration: Record<string, string>;
};

function destinationHosts(state: DestinationState): Record<string, string> {
  const hosts: Record<string, string> = {};
  const definition = connectorsByIdentifier[state.identifier];
  for (const step of definition?.steps ?? []) {
    for (const field of step.items) {
      if (
        (field.kind !== "url" && field.kind !== "hostname") ||
        field.target.kind !== "configuration"
      ) {
        continue;
      }
      const value = state.configuration[field.target.field];
      if (!value) continue;
      const candidate = /^https?:\/\//i.test(value)
        ? value
        : `https://${value}`;
      if (!URL.canParse(candidate)) continue;
      const host = new URL(candidate).host.toLowerCase();
      if (host) hosts[field.target.field] = host;
    }
  }
  return hosts;
}

export function connectorDestinationAuditMetadata(
  before: DestinationState,
  after: DestinationState
): Record<string, unknown> {
  const metadata: Record<string, unknown> = {};
  if (before.urlPattern !== after.urlPattern) {
    metadata.urlPattern = {
      from: before.urlPattern,
      to: after.urlPattern,
    };
  }

  const previousHosts = destinationHosts(before);
  const nextHosts = destinationHosts(after);
  const changedHosts = Object.fromEntries(
    [...new Set([...Object.keys(previousHosts), ...Object.keys(nextHosts)])]
      .filter((field) => previousHosts[field] !== nextHosts[field])
      .map((field) => [
        field,
        { from: previousHosts[field] ?? null, to: nextHosts[field] ?? null },
      ])
  );
  if (Object.keys(changedHosts).length > 0) {
    metadata.destinationHosts = changedHosts;
  }
  return metadata;
}
